import { useNavigate, useParams } from 'react-router-dom';

import { useAppDispatch } from 'hooks/useAppStore';
import useTenant from 'hooks/useTenant';
import { AppModule, Routes } from 'utils/constants';
import Wizard from 'components/forms/Wizard/Wizard';
import { CreateDeviceCharacteristicGroupRequestBody } from 'features/eai/eaiTypes';
import { KeyedObject } from 'models';
import { createDeviceCharacteristicGroup } from 'features/eai/thunks/deviceThunks';
import { replaceDynamicPathParams } from 'routes';
import useDeviceCharacteristicGroupWizardSteps from 'views/modules/Eai/Devices/DeviceDetail/Characteristics/GroupWizard/useDeviceCharacteristicGroupWizardSteps';

interface DeviceCharacteristicGroupWizardState {
  DeviceCharacteristicGroupName: string;
  ServiceCode: string;
}

const initialState: DeviceCharacteristicGroupWizardState = {
  DeviceCharacteristicGroupName: '',
  ServiceCode: ''
};

const I18N_ENTITY_ROOT = 'module.eai.devices';
const I18N_WIZARD_ROOT = `${I18N_ENTITY_ROOT}.deviceDetail.createDeviceCharacteristicGroupWizard`;

// ==============================|| COMPONENT ||============================== //

const DeviceCharacteristicGroupWizard = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { tenant } = useTenant();
  const { id } = useParams();

  const handleSubmit = (data: KeyedObject) => {
    const state: DeviceCharacteristicGroupWizardState =
      data as DeviceCharacteristicGroupWizardState;

    const requestBody: CreateDeviceCharacteristicGroupRequestBody = {
      name: state.DeviceCharacteristicGroupName,
      relatedService: state.ServiceCode
    };
    const requestParams = {
      requestBody,
      deviceId: id ?? '',
      callback: (deviceCharacteristicGroupId: string) => {
        navigate(
          replaceDynamicPathParams(
            Routes.EAI.DEVICES_CHARACTERISTIC_GROUP_DETAIL,
            [
              { paramName: 'tenant', value: tenant },
              { paramName: 'id', value: id },
              {
                paramName: 'deviceGroupId',
                value: deviceCharacteristicGroupId
              }
            ]
          )
        );
      }
    };

    dispatch(createDeviceCharacteristicGroup(requestParams));
  };

  const steps = useDeviceCharacteristicGroupWizardSteps(id ?? '');

  return (
    <Wizard
      module={AppModule.EAI}
      steps={steps}
      onSubmit={handleSubmit}
      initialState={initialState}
      i18nWizardRoot={I18N_WIZARD_ROOT}
      i18nEntityRoot={I18N_ENTITY_ROOT}
    />
  );
};

export default DeviceCharacteristicGroupWizard;
